export const AB_TEST_IDS = 'abtest.ids';
export const CLIENT_API_TIMEOUT = 'web.clientApi.timeout';
export const CLIENT_API_RETRY_LIMIT = 'web.retryLogic.clientApi.limit';
export const UNIFIED_EVENTS_BATCH_INTERVAL_SECS = 'unified.events.batch.interval.seconds';
export const UNIFIED_EVENTS_MAX_BATCH_COUNT = 'unified.events.max.batch.count';
export const FORCE_HTTPS_STREAMS = 'player.forceHttpsStreams.enabled';
export const PREPOPULATE_SEARCH_GUIDE_ID = 'fm.search.prePopulate';
export const mediaFormats = {
    pls: 'pls',
    tipls: 'tipls',
    hls: 'hls',
    html: 'html',
};
export const hlsMediaFormatMap = {
    m3u: mediaFormats.hls,
    m3u8: mediaFormats.hls,
};
